<template>
  <div>
    <ReportsMenu ref="ReportsMenu"></ReportsMenu>
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
import ReportsMenu from './components/reports/menu'
import Domain from './components/reports/domain'
export default {
  name: 'home-reports',
  components: {
    ReportsMenu,
    Domain
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  mounted: function () {
    this.$refs.ReportsMenu.inDefault()
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(() => (this.isRouterAlive = true))
    }
  }
}
</script>

<style lang="less">
  .home-reports {
    .ivu-card-head {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      background-color: #fff;
      height: 40px;
      padding: 5px 0 0 0;
      p {
        text-align: center;
        height: 30px;
        line-height: 30px;
        font-weight: normal;
        font-size: 15px;
      }
    }
    .no-padding-card-body .ivu-card-body {
      padding: 0;
    }
  }
</style>
